import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AnalyticEvents } from '@app/enums';
import { ApplicantIndividualMessage } from '@app/models/recruiting/applicant-individual-message.model';
import { Applicant } from '@app/models/recruiting/applicant.model';
import { ApplicantIndividualMessageService } from '@app/modules/applicant-tracker/services';
import { AnalyticService, NotificationService, NotifyService } from '@app/services';
import { AuthService } from '@app/services/auth.service';

@Component({
    styleUrls: ['./email-show.style.scss'],
    templateUrl: './email-show.template.html',
})
export class ApplicantEmailShowView {
    email: ApplicantIndividualMessage;
    applicant: Applicant;
    hasResentEmail = false;
    isLoading = false;

    constructor(
        public auth: AuthService,
        public notificationService: NotificationService,
        public analyticService: AnalyticService,
        protected notify: NotifyService,
        private applicantIndividualMessageService: ApplicantIndividualMessageService,
        private route: ActivatedRoute
    ) {
        this.email = this.route.snapshot.data.models.get('email');
        this.applicant = this.route.snapshot.data.models.get('applicant');
    }

    async resendMessage(): Promise<void> {
        this.isLoading = true;
        try {
            await this.applicantIndividualMessageService.resendMessage(this.email);
            this.hasResentEmail = true;
            this.notify.success('applicant-tracker.emailResentToApplicant');
            this.analyticService.trackEvent(AnalyticEvents.RecruitingApplicantProfileEmailHistoryResend);
        } catch (err) {
            this.notify.error('applicant-tracker.unableToResendEmail');
        }
        this.isLoading = false;
    }
}
